/**
 * Customer.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  tableName: 'cliente',

  datastore: 'app',

  display: ['sapId', 'name'],

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    createdBy: false,

    createdAt: false,

    updatedAt: false,

    id: {
      type: 'number',
      required: true,
      unique: true,
      columnName: 'clienteid'
    },

    sapId: {
      type: 'string',
      allowNull: true,
      columnName: 'number'
    },

    name: {
      type: 'string',
      allowNull: true,
      columnName: 'nombre'
    },

    rfc: {
      type: 'string',
      allowNull: true,
    },

    address: {
      type: 'string',
      allowNull: true,
      columnName: 'direccion'
    },

    neighborhood: {
      type: 'string',
      allowNull: true,
      columnName: 'colonia'
    },

    city: {
      type: 'string',
      allowNull: true,
      columnName: 'ciudad'
    },

    state: {
      type: 'string',
      allowNull: true,
      columnName: 'estado'
    },

    zipCode: {
      type: 'string',
      allowNull: true,
      columnName: 'cp'
    },

    active: {
      type: 'boolean',
      defaultsTo: false,
      columnName: 'activo'
    },

    verified: {
      type: 'boolean',
      defaultsTo: false,
      columnName: 'homol'
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    dispatches: {
      collection: 'dispatch',
      via: 'customer'
    },

    rates: {
      collection: 'rates',
      via: 'customer'
    }

  },

}




// WEBPACK FOOTER //
// ./src/models/Customer.js